// PR-F2 — card-surcharge config query-key factory (stale-after-save
// convention: queryKey arrays live only in *Keys files). One list key; the
// per-state update mutation invalidates it so the grid refreshes.

export const cardSurchargeKeys = {
  list: () => ["portfolio-admin", "card-surcharge"] as const,
};
